import { brand } from '@/config/brand';
import { cn } from './core';

/**
 * The venue logo. Dark screens get the version with white lettering (the theme is
 * class-based, so this switches with the in-app theme setting, not only the system one).
 * Size it with a height class, e.g. "h-12".
 */
export function Logo({ className }: { className?: string }) {
  return (
    <>
      <img src={brand.logo} alt={brand.business} draggable={false} className={cn('w-auto select-none dark:hidden', className)} />
      <img src={brand.logoDark} alt={brand.business} draggable={false} className={cn('hidden w-auto select-none dark:block', className)} />
    </>
  );
}
